import { render } from "./Chat.vue?vue&type=template&id=2d3ae228&scoped=true"
import script from "./chat.js?vue&type=script&lang=js"
export * from "./chat.js?vue&type=script&lang=js"

import "./chat.css?vue&type=style&index=0&id=2d3ae228&scoped=true&lang=css"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3ae228"]])

export default __exports__